import React from 'react';
import { Grid, GridProps } from '@material-ui/core';

export const GridItem: React.FC<GridProps> = props => <Grid item {...props} />;
